import { TAXONOMY, subsOf } from "@/lib/productTaxonomy";

const cls = "w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm";

export default function ProductCategoryPicker({ family, subcategory, onChange, legacy, testid = "product" }) {
  const subs = subsOf(family);
  return (
    <>
      <label className="space-y-1.5 block"><span className="text-xs text-slate-500 block">Catégorie</span>
        <select data-testid={`${testid}-family`} value={family || ""} onChange={(e) => onChange({ category: e.target.value || "autre", subcategory: "", needs_reclass: false })} className={cls}>
          <option value="">— Choisir —</option>
          {TAXONOMY.map(([c, l]) => <option key={c} value={c}>{l}</option>)}
        </select></label>
      <label className="space-y-1.5 block"><span className="text-xs text-slate-500 block">Sous-catégorie</span>
        <select data-testid={`${testid}-subcategory`} value={subcategory || ""} disabled={!subs.length} onChange={(e) => onChange({ subcategory: e.target.value, needs_reclass: false })} className={cls}>
          <option value="">{subs.length ? "— Choisir —" : "—"}</option>
          {subs.map((s) => <option key={s} value={s}>{s}</option>)}
        </select></label>
      {legacy && <p className="col-span-2 text-[11px] text-amber-700" data-testid={`${testid}-legacy`}>Ancienne catégorie : « {legacy} » — à reclasser si besoin.</p>}
    </>
  );
}
